<template>
	<div class="grid gap-4">
		<FormKit type="text" name="company" label="Maatschappij" />
		<FormKit type="loanlinkDate" name="startDate" label="Ingangsdatum" />
		<FormKit
			type="loanlinkNumeric"
			name="durationMonths"
			label="Looptijd (mnd)"
		/>
		<FormKit type="loanlinkCurrency" name="monthlyAmount" label="Maandbedrag" />
		<FormKit
			type="loanlinkOption"
			name="settledForNewMortgage"
			label="Afgelost voor nieuwe hypotheek"
			:options="{ true: 'Ja', false: 'Nee' }"
		/>
	</div>
</template>
